import styled from "styled-components";



export const DropDownHeader = styled("div")`
  width: ${p => p.width ? p.width : '100%'};
  height: ${p => p.height ? p.height : '48px'};
  border: 1px #E4E4E4 solid;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  background: #FFF;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  position: relative;
  cursor: pointer;
`;

export const DropDownListContainer = styled("div")`
  
`;

export const DropDownList = styled("ul")`
    position: absolute;
    top: 100%;
    left: 0;
    border-radius: 4px;
    padding: 0;
    margin: 0;
    background: #ffffff;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    max-height: 250px;
    overflow-y: auto;
    z-index: 1;
`;

export const ListItem = styled("li")`
  list-style: none;
  padding: 16px 12px;
  color: ${props => props.active === "true" ? '#000000' : ''};
  font-weight: ${props => props.active === "true" ? '700' : ''};
  background: ${props => props.active === "true" ? '#F1F9FF' : ''};
  border-bottom: 1px solid #D7E6F1;
  cursor: pointer;
  :hover{
    background-color: #F1F9FF;
  }
  :last-child{
    border-bottom: 0;
  }
`;



export const SelectContainer = styled.div`
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  width: 100%;

  position: relative;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */

  .calenderIcon{
    background-position: ${props => props.isOpen ? '-124px -25px' : '-124px 0.5px'};
    width: 19px;
    height: 24px;
    margin-right: 8px;
  }


`



export const DownArrow = styled.i`

  border: ${props => props.isOpen ? 'solid #008CFF' : 'solid #4A4A4A'};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  position: absolute;

  right: 3px;
  top: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
`